export default __webpack_public_path__ + "static/media/background2.db9e545a.jpg";